export const Level1 = `Level1`;
export const Level2 = `Level2`;
export const Level3 = `Level3`;
export const Level4 = `Level4`;
export const Level5 = `Level5`;